import axiosWithToken from "../../../utils/components/axiosTokenConfig";
import { BASE_URL, SRF_ID_BASE } from "../../../global";
import { toast } from "react-toastify";
import { clearPreviousReadings } from "../helper";
import moment from "moment";
import { allSettings } from "../../../utils/components/allSettings";
import { locationOptions } from "../../../constants/srfConstants";

const processData = (settings, indicators, dispatch) => {
  let amd = false,
    calTypeSetting = false;

  let _settings = {};
  settings?.forEach((setting) => {
    _settings[setting.keyName] = setting.value;
    if (
      setting.keyName === "amendment" &&
      setting.value.toLowerCase() === "true"
    ) {
      amd = true;
    } else if (
      setting.keyName === "Calibration Type" &&
      setting.value.toLowerCase() === "true"
    ) {
      calTypeSetting = true;
    }
  });
  dispatch({
    field: "indicators",
    value: {
      ...indicators,
      isShowAmendment: amd,
      isCalTypeSetting: calTypeSetting,
    },
  });
  dispatch({
    field: "settings",
    value: _settings,
  });
};

export function fetchSettings(indicators, dispatch) {
  try {
    axiosWithToken
      .get(BASE_URL + `settings?_where=(status,eq,1)`)
      .then((res) => {
        processData(res.data, indicators, dispatch);
        sessionStorage.setItem("fetchallSettings",JSON.stringify(res.data));
      });
  } catch (err) {
    if (err.message !== "request_aborted") {
      toast.error("Failed to fetch settings");
    }
  }
}

function prepareAndSetDatasheet(datasheetDetails, dispatch) {
  let range_low = [];
  let range_high = [];
  let ranges = datasheetDetails?.ranges?.split("||");
  ranges?.forEach((range) => {
    range_low.push((range.split("|")[0]?.match(/[+-\d\.]+/g) || [])[0]);
    range_high.push((range.split("|")[1]?.match(/[+-\d\.]+/g) || [])[0]);
  });

  // 2. calculate next due date if not present
  if (!datasheetDetails?.nextDueDate) {
    let calibrationDate = datasheetDetails.calibrationDate;

    let calibrationFrequency = datasheetDetails.calibrationFrequency;
    if (
      calibrationFrequency &&
      calibrationDate &&
      calibrationFrequency !== "Not Required" &&
      calibrationFrequency !== "Customer Defined"
    ) {
      datasheetDetails["nextDueDate"] = new Date(
        moment(calibrationDate)
          .add(calibrationFrequency?.split(" ")?.[0] || 0, "M")
          .format("YYYY-MM-DD"),
      );
    } else {
      datasheetDetails["nextDueDate"] = null;
    }
  } else {
    datasheetDetails["nextDueDate"] = new Date(datasheetDetails.nextDueDate);
  }

  dispatch({
    field: "datasheetDetails",
    value: {
      ...datasheetDetails,
      range_low: range_low.join("||"),
      range_high: range_high.join("||"),
    },
  });
}

export async function fetchDatasheet(datasheetId, indicators, dispatch) {
  let url = BASE_URL;
  return axiosWithToken
    .get(
      url +
        `xjoin?_join=ds.datasheets,_j,ins.instruments,_j,cust.clients,_j,disc.discipline&_on1=(ds.instrumentId,eq,ins.id)&_on2=(cust.id,eq,ds.clientId)&_on3=(ins.disciplineId,eq,disc.id)&_fields=ds.lastModified,ds.amendment,ds.revisionNumber,ds.calibratedby,ds.datasheetApprovedBy,ds.clientId,cust.companyName,ins.instrumentName,ds.jobNumber,ds.requestedname,ds.datasheetImages,ds.id,ds.make,ds.dcNumber,ds.dcDate,ds.lc,ds.instrumentId,ds.deletedTableIds,ins.standardMasterIds,ds.ranges,ds.operatingRange,ins.calibrationProcedureNo,ins.referenceStandards,ds.isaStandard,cust.address,ds.dcNumber,ds.calibrationDate,ds.datasheetApprovedDate,ds.endCalibrationDate,ds.dcDate,ds.nextDueDate,ds.receiptDate,ds.calProcRefNo,ds.mfgNo,ds.identificationNo,ds.startTemp,ds.middleTemp,ds.endTemp,ds.startLiquidTemp,ds.middleLiquidTemp,ds.endLiquidTemp,ds.additionalStandardIds,ds.DUCID,ds.calibrationType,ds.specificValues,ds.location,ds.serialNumber,ds.accuracy,ds.poNumber,ds.poDate,ds.dateOfIssue,ds.model,ds.ConOfDuc,ds.calPoint,ds.calMethod,ds.locationOfInstrument,ds.srnNo,ds.configuration,ds.startPressure,ds.middilePressure,ds.endPressure,ds.tableDisplayStatus,ds.startHumidity,ds.middleHumidity,ds.endHumidity,disc.startTemp,disc.endTemp,disc.startHumidity,disc.endHumidity,disc.id,disc.name,disc.disciplineKey,disc.remarks,ds.extraColumns,ds.readingsGroupByDetails,ds.serviceReqNumber,ds.calibrationReason,ds.calFrequency,ds.complianceStatus&_where=(ds.id,eq, ${datasheetId})`,
    )
    .then((res) => {
      if (res.data.length > 0 && res.data[0] != null) {
        let data = res.data[0];
        let datasheetDetails = {
          id: datasheetId,
          jobNumber: data.ds_jobNumber,
          calibrationFrequency: data.ds_calFrequency || "",
          revisionNumber: data.ds_revisionNumber,
          clientId: data.ds_clientId,
          clientIdNumber: data.ds_clientId,
          clientName: data.cust_companyName,
          instrumentName: data.ins_instrumentName,
          requestedname: data.ds_requestedname ? data.ds_requestedname : "",
          instrumentId: data.ds_instrumentId,
          make: data.ds_make,
          lc: data.ds_lc,
          defaultRemark: data.disc_remarks || "",
          ranges: data.ds_ranges,
          operatingRange: data.ds_operatingRange,
          dcDate: data.ds_dcDate ? data.ds_dcDate : "",
          dcNo: data.ds_dcNumber,
          deletedTableIds: data.ds_deletedTableIds,
          referenceStandards: data.ins_referenceStandards,
          calibrationProcedureNo: data.ins_calibrationProcedureNo,
          calibrationDate: data.ds_calibrationDate
            ? data.ds_calibrationDate
            : "",
          endCalibrationDate: data.ds_endCalibrationDate
            ? data.ds_endCalibrationDate
            : "",
          datasheetApprovedDate: data.ds_datasheetApprovedDate
            ? data.ds_datasheetApprovedDate
            : "",
          nextDueDate: data.ds_nextDueDate ? data.ds_nextDueDate : "",
          receiptDate: data.ds_receiptDate ? data.ds_receiptDate : "",
          mfgNo: data.ds_mfgNo,
          startTemp: data.ds_startTemp
            ? data.ds_startTemp
            : data.disc_startTemp,
          middleTemp: data.ds_middleTemp,
          endTemp: data.ds_endTemp ? data.ds_endTemp : data.disc_endTemp,
          startHumidity: data.ds_startHumidity
            ? data.ds_startHumidity
            : data.disc_startHumidity,
          middleHumidity: data.ds_middleHumidity,
          endHumidity: data.ds_endHumidity
            ? data.ds_endHumidity
            : data.disc_endHumidity,
          startLiquidTemp: data.ds_startLiquidTemp,
          middleLiquidTemp: data.ds_middleLiquidTemp,
          endLiquidTemp: data.ds_endLiquidTemp,
          identificationNo: data.ds_identificationNo,
          DUCID: data.ds_DUCID,
          location: locationOptions.find(opt => opt.id == data.ds_location)?.label || "",
          accuracy: data.ds_accuracy,
          serialNo: data.ds_serialNumber,
          poNo: data.ds_poNumber,
          poDate: data.ds_poDate,
          dateOfIssue: data.ds_dateOfIssue,
          model: data.ds_model,
          conOfDuc: data.ds_ConOfDuc,
          calPoint: data.ds_calPoint,
          calMethod: data.ds_calMethod,
          locationOfInstrument: data.ds_locationOfInstrument,
          configuration: JSON.parse(data.ds_configuration) || {},
          startPressure: data.ds_startPressure,
          middilePressure: data.ds_middilePressure,
          endPressure: data.ds_endPressure,
          disciplineId: data.disc_id,
          disciplineName: data.disc_name,
          disciplineKey: data.disc_disciplineKey,
          tableDisplayStatus: data.ds_tableDisplayStatus,
          extraColumns: Object.entries(JSON.parse(data.ds_extraColumns)),
          amendmentHistory: data.ds_amendment,
          calibrationReason: data.ds_calibrationReason,
          calProcRefNo: data?.ds_calProcRefNo,
          isaStandard: data?.ds_isaStandard,
          calibrationType: data?.ds_calibrationType,
          complianceStatus: data?.ds_complianceStatus,
        };
        prepareAndSetDatasheet(datasheetDetails, dispatch);

        dispatch({
          field: "readingsGroupByDetails",
          value: JSON.parse(data?.ds_readingsGroupByDetails),
        });

        dispatch({
          field: "standardMasterDetails",
          value: { standardMasterIds: data?.ins_standardMasterIds },
        });

        dispatch({
          field: "datasheetImages",
          value: data.ds_datasheetImages?.split(",") || [],
        });

        dispatch({
          field: "indicators_complianceStatus",
          value: data?.ds_complianceStatus == 1 ? true : false,
        });

        // TODO: move both the below calls into separate function
        axiosWithToken
          .get(
            BASE_URL +
              `srfs?_fields=serviceReqNumber,id,entryDate,customerAnnextureFilePaths,companyHierarchy&_where=(serviceReqNumber,eq,${res.data[0]?.ds_serviceReqNumber})`,
          )
          .then((res) => {
            dispatch({
              field: "srfDetails",
              value: {
                srfNumber: res.data[0]?.serviceReqNumber,
                entryDate: res.data[0]?.entryDate,
                customerAnnextureFilePaths:
                  res.data[0]?.customerAnnextureFilePaths,
                srfId: res.data[0]?.id,
                companyHierarchy: res.data[0]?.companyHierarchy,
              },
            });
          });

        if (res.data[0].ds_calibratedby) {
          axiosWithToken
            .get(BASE_URL + `users/${res.data[0].ds_calibratedby}`)
            .then((res) => {
              const userData = res.data[0];
              const calibratedByUsername = userData?.userName || "";
              const calibratedByImgSign = userData?.usersign || "";
              dispatch({
                field: "calibratedBy",
                value: calibratedByUsername,
              });
              dispatch({
                field: "calibratedByImgSign",
                value: calibratedByImgSign,
              });
            })
            .catch((err) => console.error("Error fetching user data:", err));
        }
        if (res.data[0].ds_datasheetApprovedBy) {
          axiosWithToken
            .get(BASE_URL + `users/${res.data[0].ds_datasheetApprovedBy}`)
            .then((res) => {
              const userData = res.data[0];
              const datasheetApprovedByUsername = userData?.userName || "";
              const datasheetApprovedByImgSign = userData?.usersign || "";
              dispatch({
                field: "datasheetApprovedBy",
                value: datasheetApprovedByUsername,
              });
              dispatch({
                field: "datasheetApprovedByImgSign",
                value: datasheetApprovedByImgSign,
              });
            })
            .catch((err) => console.error("Error fetching user data:", err));
        }
      }
    })
    .catch((err) => {
      console.error("datasheet data fetching error: ", err);
    });
}

export const fetchCertificateDetails = (datasheetId, dispatch) => {
  axiosWithToken
    .get(
      BASE_URL + `certificates/${datasheetId}?_fields=certificateNumber,ULRNo,approvedby`,
    )
    .then((res) => {
      dispatch({
        field: "certificateDetails",
        value: {
          certificateNumber: res.data[0]?.certificateNumber,
          ULRNo: res.data[0]?.ULRNo,
          serviceReqNumber: res.data[0]?.serviceReqNumber,
          status: res.data[0]?.status,
          approvedby:res.data[0]?.approvedby || "",
        },
      });
    });
};

export function fetchDatasheetStaticTables(
  instrumentId,
  deletedTableIds,
  setDerivedColumns,
  setTableConfig,
  dispatch,
  table_id,
) {
  let url = BASE_URL;
  deletedTableIds = deletedTableIds?.split(",")?.map((id) => Number(id));
  let data_url = table_id
    ? `datasheetStaticTables/${table_id}`
    : `datasheetStaticTables?_where=(instrumentId,eq,${instrumentId})`;
  return axiosWithToken
    .get(url + data_url)
    .then((res) => {
      if (deletedTableIds) {
        res.data = res.data.filter((row) => !deletedTableIds.includes(row.id));
      }
      if (res.data.length > 0) {
        let tmp = {};
        let cMap = {};
        res.data.map((table) => {
          tmp[table.id] = {
            isUncertainty: table.isUncertainty,
            isVerticalUncertainty: table.isVerticalUncertainty,
            isAutomated: table.isAutomated,
            defaultValues: JSON.parse(table.defaultConfiguration)?.values,
          };
          cMap[table.id] = Object.keys(
            JSON.parse(table.defaultConfiguration).formulas,
          );
        });

        // pre process res.data
        res.data = res.data.map((table) => {
          return {
            ...table,
            defaultConfiguration: JSON.parse(
              table?.defaultConfiguration || null,
            ),
          };
        });

        dispatch({
          field: "staticTables",
          value: res.data,
        });
        setDerivedColumns({ ...cMap });
        setTableConfig(tmp);
      } else {
        dispatch({
          field: "staticTables",
          value: [],
        });
        setDerivedColumns({});
        setTableConfig({});
      }
    })
    .catch((err) => {
      console.error(
        "[ERROR] Failed to fetch datasheet static tables, error: ",
        err,
      );
      return err;
    });
}

export function fetchCertificateStaticTables(
  instrumentId,
  deletedTableIds = "",
  dispatch,
) {
  let url = BASE_URL;
  return axiosWithToken
    .get(
      url + `certificateStaticTables?_where=(instrumentId,eq,${instrumentId})`,
    )
    .then((res) => {
      // pre process res.data
      res.data = res.data.map((table) => {
        return {
          ...table,
          defaultConfiguration: JSON.parse(table?.defaultConfiguration || null),
        };
      });

      dispatch({
        field: "certificateStaticTables",
        value: res.data,
      });

      return res;
    })
    .catch((err) => {
      console.error("certificate static tables data fetching error: ", err);
      return err;
    });
}

export function fetchStaticReadingRows(
  datasheetId,
  dispatch,
  isAutoload = false,
  currentDatasheetId = 0,
  deletedTableIds = "",
  selectedMasterORNot = false,
) {
  let url = BASE_URL;
  let datasheetReadingsQuery;
  // for static datasheet
  if (isAutoload) {
    datasheetReadingsQuery = `SELECT * FROM datasheetReadingView where datasheetId = ${datasheetId} `;
  } else {
    datasheetReadingsQuery = `select * from datasheetStaticReadings where datasheetId = ${datasheetId}`;
  }
  if (deletedTableIds) {
    datasheetReadingsQuery += ` and tableId not in(${deletedTableIds})`;
  }

  return Promise.all([
    axiosWithToken
      .post(BASE_URL + `dynamic`, { query: datasheetReadingsQuery })
      .then((res) => {
        // if isAutoload is true, then change datasheetId to currentDatasheetId, and set id to 0
        if (isAutoload) {
          res.data = res.data.map((e) => {
            e.datasheetId = currentDatasheetId;
            e.id = 0;
            return e;
          });
        }
        if (selectedMasterORNot) {
          res.data = res.data.map((data) => {
            return {
              ...data,
              standardRanges: null,
              supportiveRanges: null,
            };
          });
        }
        dispatch({
          field: "datasheetStaticReadings",
          value: res.data,
        });

        // extraxt standardIds from standardRanges and set to selectedStandardIds context
        let standardIds = res.data.map((e) => e.standardRanges).filter(Boolean);

        const selectedStandardIds = [];

        standardIds.forEach((str) => {
          str.split(",").forEach((sub) => {
            const num = parseInt(sub.split(":")[0]);
            if (!selectedStandardIds.includes(num)) {
              selectedStandardIds.push(num);
            }
          });
        });

        // find selected SupportiveIds
        let supportiveIds = res.data
          .map((e) => e.supportiveRanges)
          .filter(Boolean);

        const selectedSupportiveIds = [];

        supportiveIds.forEach((str) => {
          str.split(",").forEach((sub) => {
            const num = parseInt(sub.split(":")[0]);
            if (!selectedSupportiveIds.includes(num)) {
              selectedSupportiveIds.push(num);
            }
          });
        });

        const joinedString = [
          ...selectedStandardIds,
          ...selectedSupportiveIds,
        ]?.join(",");

        dispatch({
          field: "selectedMastersIds",
          value: joinedString,
        });

        dispatch({
          field: "selectedStandardIds",
          value: [...new Set(selectedStandardIds)],
        });
        sessionStorage.setItem("selectedMastersIds", joinedString || "");
      })
      .catch((err) => {
        console.error(
          "[ERROR] Failed to load datasheet reading rows, error: ",
          err,
        );
      }),
  ]);
}

export async function fetchbeforeAutoloadJobNumber(
  datasheetId,
  datasheetDetails,
) {
  try {
    let queries = [];
    if (datasheetDetails?.model && !["-", "--", "NA"].includes(datasheetDetails?.model) && datasheetDetails?.make && datasheetDetails?.disciplineKey == "0" ) {
      queries.push(`
       SELECT * FROM datasheetview WHERE status = 1 AND totalReadings > 0 AND id != ${datasheetId} AND instrumentId = ${datasheetDetails?.instrumentId} AND model = '${datasheetDetails?.model}' AND make = '${datasheetDetails?.make}'
      `);
    }
    
    if (datasheetDetails?.ranges && datasheetDetails?.lc) {
      queries.push(`
        SELECT * FROM datasheetview WHERE status = 1 AND totalReadings > 0 AND id != ${datasheetId} AND instrumentId = ${datasheetDetails?.instrumentId} AND ranges LIKE '${datasheetDetails?.ranges.replaceAll("#", "_")}' AND lc LIKE '${datasheetDetails?.lc.replaceAll("#", "_")}'
      `);
    }

    if (
      datasheetDetails?.DUCID &&
      datasheetDetails?.ranges &&
      datasheetDetails?.lc
    ) {
      queries.push(`
        SELECT * FROM datasheetview WHERE status = 1 AND totalReadings > 0 AND id != ${datasheetId} AND instrumentId = ${datasheetDetails?.instrumentId} AND DUCID = '${datasheetDetails?.DUCID}' AND ranges LIKE '${datasheetDetails?.ranges.replaceAll("#", "_")}' AND lc LIKE '${datasheetDetails?.lc.replaceAll("#", "_")}'
      `);
    }
    
    // Fetch datasheets
    let res = [];
    for (let i = 0; i < queries.length; i++) {
      res = await axiosWithToken.post(BASE_URL + "dynamic", { query: queries[i].trim() });
      if (res.data.length > 0) break;
    }

    // Set job numbers to state
    let jobDetails =
      res?.data?.map((item) => ({
        id: item.id,
        jobNumber: item.JobNumber,
      })) || [];
    return jobDetails;
  } catch (error) {
    console.error("Error fetching job numbers:", error);
    return []; // Return empty array in case of error
  }
}

// TODO: simplify this function
export async function fetchOtherStaticReadingRows(
  datasheetId,
  datasheetStaticReadings,
  datasheetDetails,
  dispatch,
) {
  // 1. prepare query for fetching datasheet
  let queries = [];
  if (datasheetDetails?.DUCID)
    queries = queries.concat([
      `datasheets?_where=(totalReadings,gt,0)~and(id,ne,${datasheetId})~and(instrumentId,eq,${datasheetDetails?.instrumentId})~and(DUCID,eq,${datasheetDetails?.DUCID})`,
    ]);
  if (datasheetDetails?.ranges && datasheetDetails?.lc)
    queries = queries.concat([
      `datasheets?_where=(totalReadings,gt,0)~and(id,ne,${datasheetId})~and(instrumentId,eq,${
        datasheetDetails?.instrumentId
      })~and((ranges,like,${datasheetDetails?.ranges.replaceAll(
        "#",
        "_",
      )})~and(lc,like,${datasheetDetails?.lc.replaceAll("#", "_")}))`,
    ]);
  if (datasheetDetails?.model)
    queries = queries.concat([
      `datasheets?_where=(totalReadings,gt,0)~and(id,ne,${datasheetId})~and(instrumentId,eq,${datasheetDetails?.instrumentId})~and(model,ne,${datasheetDetails?.model})`,
    ]);
  if (datasheetDetails?.serialNo)
    queries = queries.concat([
      `datasheets?_where=(totalReadings,gt,0)~and(id,ne,${datasheetId})~and(instrumentId,eq,${datasheetDetails?.instrumentId})~and(serialNumber,ne,${datasheetDetails?.serialNo})`,
    ]);

  // 2. fetch datasheet having >1 readings
  let res = [];
  for (let i = 0; i < queries.length; i++) {
    res = await axiosWithToken.get(BASE_URL + queries[i]);
    if (res.data.length > 0) break;
  }

  // 3. pick random datasheetId from the fetched datasheets
  let datasheetIds = res.data?.map((row) => row.id);
  let _datasheetId = 0;
  if (datasheetIds?.length > 0) {
    _datasheetId =
      datasheetIds[Math.floor(Math.random() * datasheetIds.length)];

    // 4. clear previous readings
    let readingIds = datasheetStaticReadings
      .filter((e) => e.datasheetId == datasheetId)
      .map((row) => row.id);
    if (readingIds.length > 0)
      await clearPreviousReadings(
        "datasheetStaticReadings",
        "datasheetId",
        datasheetId,
      );

    // 5. fetch readings for the selected datasheet
    fetchStaticReadingRows(
      _datasheetId,
      dispatch,
      true,
      datasheetId,
      datasheetDetails?.deletedTableIds,
    );
  }
}

export async function fetchafterAutoloadJobNumber(
  datasheetId,
  datasheetStaticReadings,
  datasheetDetails,
  dispatch,
  selectedDatasheetID,
  selectedMasterORNot,
) {
  // 1. selected jobnumber datasheetId
  let datasheetIds = selectedDatasheetID;
  if (datasheetIds) {
    // 2. clear previous readings
    let readingIds = datasheetStaticReadings
      .filter((e) => e.datasheetId == datasheetId)
      .map((row) => row.id);
    if (readingIds.length > 0)
      await clearPreviousReadings(
        "datasheetStaticReadings",
        "datasheetId",
        datasheetId,
      );

    // 3. fetch readings for the selected datasheet
    fetchStaticReadingRows(
      datasheetIds,
      dispatch,
      true,
      datasheetId,
      datasheetDetails?.deletedTableIds,
      selectedMasterORNot,
    );
  }
}

function fetchStandardRanges(ids = [], dispatch) {

  const formattedArray = ids?.[0]
  ?.split(",")
  ?.map(id => `'${id.trim()}'`)
  ?.join(",");

  const convertStandardData = {
    ds_disciplineKey: "dsKey",
    pl_id: "id",
    pl_stId: "stId",
    pl_standardName: "title",
    pl_type: "type",
    pl_masterleastcount: "masterleastcount",
    pr_id: "rangeId",
    pr_rangeName: "range",
    pr_accuracy: "accuracy",
    pr_gravity: "lc",
    pr_uniformity: "uniformity",
    pr_stability: "stability",
    pr_mode: "mode",
    pr_parameter: "parameter",
    pr_etParameter: "etParameter",
    pr_paratype: "paratype",
    pr_reactionTime: "reactionTime",
    pr_cmv: "cmv",
    pr_mpe: "mpe",
    pr_drift: "drift",
    pr_materialDensity: "materialDensity",
    pr_deviation: "deviation",
  };

  axiosWithToken
    .post(
      BASE_URL +"dynamic",
      {query: `SELECT pl.standardName as title, pr.rangeName as \`range\`, pl.id, pr.id as rangeId, pl.stId, pr.accuracy, pr.gravity as lc, pr.uniformity, pr.mode, pr.parameter, pr.etParameter, pr.paratype, pr.stability, pr.reactionTime, pr.cmv, pr.drift, pr.mpe, pr.materialDensity, pr.deviation, pl.type, pl.masterleastcount, pl.make, pl.traceability, pl.calDate, pl.validUpto, ds.disciplineKey as dsKey FROM standards AS pl JOIN standardRanges AS pr ON pl.id = pr.standardId JOIN discipline AS ds ON pl.disciplineId = ds.id WHERE pl.status != -1 AND pl.stId IN (${formattedArray})`}

      // 1. fetch standard masters
    )
    .then((res) => {

      // 2. process standard ranges data directly from res.data

      // let allStandardRangesData = [];
      // res.data.forEach((d) => {
      //   allStandardRangesData.push({});
      //   Object.entries(d).forEach(
      //     (e) =>
      //       (allStandardRangesData[allStandardRangesData.length - 1][
      //         convertStandardData[e[0]] || e[0]
      //       ] = e[1]),
      //   );
      // });
      let standardRangesData = res.data.filter(
        (st) => st.type == 1,
      );
      sessionStorage.setItem("standardRangesData", JSON.stringify(standardRangesData || []));
      dispatch({
        field: "standardRanges",
        value: standardRangesData,
      });

      let supportiveStandardMasterArray = res.data.filter(
        (st) => st.type == 2,
      );
      sessionStorage.setItem("supportiveStandardMasterArray", JSON.stringify(supportiveStandardMasterArray || []));
      dispatch({
        field: "supportiveStandardMasterArray",
        value: supportiveStandardMasterArray,
      });
    })
    .catch((err) => {
      console.error("standards data fetching error: ", err);
    });
}

export function fetchUnits(disciplineId, dispatch) {
  return axiosWithToken
    .get(
      BASE_URL +
        "unit?_where=(status,eq,1)" +
        (disciplineId ? `~and(disciplineId,eq,${disciplineId})` : ""),
    )
    .then((res) => {
      let unitSymbols = res.data.reduce((prev, current) => {
        return [...prev, current.symbol];
      }, []);
      unitSymbols = [...new Set(unitSymbols)];

      dispatch({
        field: "units",
        value: res.data,
      });

      dispatch({
        field: "unitSymbols",
        value: unitSymbols,
      });
    })
    .catch((err) => {
      console.error("unit fetching error: ", err);
      return err;
    });
}

export function fetchCmcReadings(instrumentId, dispatch, calibrationDate) {
  calibrationDate = moment(calibrationDate).format("YYYY-MM-DD");
  let query =`SELECT * FROM cmc where instrumentId=${instrumentId} AND (DATE('${calibrationDate}') BETWEEN DATE(fromDate) AND DATE(toDate))`;
  return axiosWithToken
    .post(BASE_URL + `dynamic`, {query})
    .then((res) => {
      dispatch({
        field: "cmcDetails",
        value: {
          cmcReadings: res.data,
        },
      });
    })
    .catch((err) => {
      console.error("Something Went Wrong while fetching standardRanges!");
      return err;
    });
}

// instrumentDetails section
// TODO: combine below 2 functions into 1 react hook
const filterMastersBasedOnPurpose = async (mst) => {
  if (!mst) return mst;
  let mstArray = mst.split(",");
  // Get current date for comparison
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set to beginning of today
  let query = {
    query: `SELECT s.*, st.stId FROM standardInOut s LEFT JOIN standards st ON s.standardId = st.id  WHERE s.status = 1 AND st.stId IN ('${mstArray.join("','")}')`,
  };

  let standardinout = await axiosWithToken.post(BASE_URL + "dynamic", query);
  // Get the list of stIds to exclude:
  // 1. Where purpose is "self-calibration" AND either:
  //    a. returnDate is NULL (not returned yet), OR
  //    b. returnDate is in the future (after today's date)
  let excludedStIds = standardinout.data
    ?.filter((d) => {
      // Check if purpose is self-calibration
      if (d.purpose.toLowerCase() === "self-calibration") {
        // If no return date, exclude it
        if (!d.returnDate) return true;

        // Convert return date string to Date object
        const returnDate = new Date(d.returnDate);
        returnDate.setHours(0, 0, 0, 0);

        // If return date is in the future (after today), exclude it
        if (returnDate > today) return true;
      }
      return false;
    })
    .map((e) => e.stId);

  // Filter out mstArray elements that are in excludedStIds
  let filteredMstArray = mstArray.filter(
    (stId) => !excludedStIds.includes(stId)
  );

  if (filteredMstArray.length === 0) return "";
  return filteredMstArray.join(",");
};

const filterAllowedMasters = async (mst, settings, referenceData, calibrationDate) => {
  mst = await filterMastersBasedOnPurpose(mst);
  const formattedCalibrationDate = calibrationDate ? new Date(calibrationDate).toISOString().split('T')[0] : "";

  let locations = referenceData?.srfInstruments?.location;
  let userType = Number(localStorage.getItem("type"));
  const user = [localStorage.getItem("id"), localStorage.getItem("userName")];

  if (!mst) return mst;

  if (!settings?.["Master-Inout"] || settings?.["Master-Inout"] == "false") {
    return mst;
  } else {    
    if(locations == 1 || locations == 3 || userType != 2){
      return mst;
    } else {
  mst = (mst || "").split(",").map((e) => e.split(":")[0]);
  if (mst === "") return mst;
  let res = null;
  let SQLQuery = {
    query: `SELECT s.*, st.stId FROM standardInOut s LEFT JOIN standards st ON s.standardId = st.id WHERE s.status = 1 AND s.userId in ('${user[0]}') AND (s.returnDate IS NULL ${formattedCalibrationDate ? `OR s.returnDate >= '${formattedCalibrationDate}'` : ''}) AND st.stId IN ('${mst.join("','")}');`
  };

  res = await axiosWithToken.post(BASE_URL + "dynamic", SQLQuery);
  let standardInOutData = res.data
    .filter((d) => d.purpose.toLowerCase() != "self-calibration")
    .map((e) => e.stId)
    .join(",")
    .split(",");

  let filterMST = mst?.filter((c) => standardInOutData?.includes(c));

  // if (res.data.length > 0 && filterMST.length > 0) {
    mst = filterMST;
    // return mst?.join(",")
  // }

  // let finalStandardIDS=referenceData["srfInstruments"]?.location == "Onsite" ? "" : mst?.join(",")

  //   return finalStandardIDS

  return mst?.join(",");
    }
  }
};

export function fetchInstrument(instrumentId, dispatch, referenceData, settings, calibrationDate) {
  let url = BASE_URL;
  let sqlQuery = {
    query: `SELECT instruments.*, remarks.value as instrumentRemark FROM instruments LEFT JOIN remarks ON remarks.id = instruments.remarkId WHERE instruments.id = ${instrumentId}`,
  };
  return axiosWithToken
    .post(url + `dynamic`, sqlQuery)
    .then(async (res) => {
      if (res.data.length > 0) {
        dispatch({
          field: "instrumentDetails",
          value: res.data[0],
        });

        // extract standard ids
        let rawStandardIds = await filterAllowedMasters(
          res.data[0]?.standardMasterIds,
          settings,
          referenceData,
          calibrationDate
        );

        let standardIds = rawStandardIds
          .split(",")
          .map((value) => value.split(":")[0]);

        let rawSupportiveInstrumentMasterData =
          res.data[0]?.supportiveInstrumentMasterData || "";
        let supportiveInstrumentIds = rawSupportiveInstrumentMasterData
          .split(",")
          .map((value) => value.split(":")[0]);

        if (standardIds.length > 0 || supportiveInstrumentIds.length > 0)
          fetchStandardRanges(
            [standardIds.join(","), supportiveInstrumentIds.join(",")],
            dispatch,
          );
      }
      return res;
    })
    .catch((err) => {
      console.error("instrumentDetails data fetching error: ", err);
      return err;
    });
}

// TODO: combine this function with fetchStandard
export async function fetchAllowedStandards(
  standardMasterIds,
  dispatch,
  referenceData,
  settings,
  calibrationDate
) {
  let combineArray = await filterAllowedMasters(standardMasterIds, settings, referenceData, calibrationDate);

  const formattedArray = combineArray
  ?.split(",")
  ?.map(id => `'${id.trim()}'`)
  ?.join(",");

const SQLQuery = {
  query: `SELECT * FROM standards WHERE stId IN (${formattedArray}) AND status != -1`
};

  return axiosWithToken
    .post(BASE_URL + `dynamic`, SQLQuery)
    .then((res) => {
      dispatch({
        field: "standardMasterArray",
        value: [...res?.data],
      });

      sessionStorage.setItem("standardMasterArray", JSON.stringify(res?.data || []));


      return res;
    });
}

export function getReferenceData(datasheetId, dispatch) {
  let tables = ["srfInstruments"];
  let newReferenceData = {};
  axiosWithToken.get(`${BASE_URL}${tables[0]}/${datasheetId}`).then((res) => {
    newReferenceData[`${tables[0]}`] = res.data[0];
    dispatch({
      field: "referenceData",
      value: {
        ...newReferenceData,
      },
    });
  });
}

export const fetchDisciplineDetails = (id, dispatch) => {
  axiosWithToken
    .get(
      BASE_URL +
        `xjoin?_join=ds.datasheets,_j,ins.instruments,_j,disc.discipline&_on1=(ds.instrumentId,eq,ins.id)&_on2=(ins.disciplineId,eq,disc.id)&_fields=disc.documentNumber,disc.issueNo,disc.issueDate,disc.amendmentNo,disc.amendmentDate&_where=(disc.id,eq,${id})`,
    )
    .then((res) => {
      dispatch({
        field: "disciplineDetails",
        value: {
          documentNumber: res.data[0]?.disc_documentNumber || "",
          issueNo: res.data[0]?.disc_issueNo || "",
          issueDate: res.data[0]?.disc_issueDate || "",
          amendmentNo: res.data[0]?.disc_amendmentNo || "",
          amendmentDate: res.data[0]?.disc_amendmentDate || "",
        },
      });
    });
};

export function fetchDatasheetReadingsAdditionalInfo(datasheetId, dispatch) {
  let fetchQuery = {
    query: `select * FROM datasheetReadingsAdditionalInfo WHERE datasheetReadingId=${datasheetId}`,
  };
  return axiosWithToken
    .post(BASE_URL + "dynamic", fetchQuery)
    .then((res) => {
      // Function to filter keys with non-null values
      function filterKeys(obj) {
        const filteredObj = {};
        Object.keys(obj).forEach((key) => {
          if (
            obj[key] !== null &&
            key !== "id" &&
            key !== "status" &&
            key !== "lastModified"
          ) {
            filteredObj[key] = obj[key];
          }
        });
        return filteredObj;
      }

      // Map and filter the res.data
      const filteredDataArray = res.data.map((obj) => filterKeys(obj));

      dispatch({
        field: "DatasheetReadingsAdditionalInfo",
        value: filteredDataArray,
      });
    })
    .catch((err) => {
      console.error("unit fetching error: ", err);
      return err;
    });
}

export function updateCertificateNumberDatsheet(
  certificateNumber,
  format,
  currentDate,
) {
  // Function to extract date format from the given format string
  const extractDateFormat = (format) => {
    const dateRegex = /[YMD]{2,4}[\/\-]?[YMD]{0,4}[\/\-]?[YMD]{0,4}/;
    const match = format.match(dateRegex);
    return match ? match[0] : "DDMMYYYY";
  };

  // Function to format the date according to the provided format
  const formatDate = (date, format) => {
    const yy = String(date.getFullYear()).slice(-2);
    const yyyy = String(date.getFullYear());
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return format
      .replace("YYYY", yyyy)
      .replace("YY", yy)
      .replace("MM", mm)
      .replace("DD", dd);
  };
  // Extract date format from the certificateDateFormate
  const dateFormat = extractDateFormat(format);
  const oldDateRegex = new RegExp(
    dateFormat.replace(/[YMD]{2,4}/g, "\\d{2,4}").replace(/[\/\-]/g, "\\$&"),
  );
  const oldDateMatch = certificateNumber.match(oldDateRegex);

  if (!oldDateMatch) {
    return certificateNumber;
  }

  const oldDate = oldDateMatch[0];
  const formattedDate = formatDate(currentDate, dateFormat);

  // Replace the old date with the new formatted date
  const newCertificateNumber = certificateNumber.replace(
    oldDate,
    formattedDate,
  );

  return newCertificateNumber;
}

export async function getRemarksData(dispatch) {
  let paylod = {
    query: `SELECT label, value, id  FROM remarks`,
  };
  axiosWithToken
    .post(BASE_URL + `dynamic`, paylod)
    .then((res) => {
      dispatch({
        field: "Remarks",
        value: res?.data,
      });
    })
    .catch((err) => {
      console.error("remark data fetching error: ", err);
    });
}

export async function clientSettingFetch(
  datasheetDetails,
  settings,
  srfDetails,
  dispatch,
) {
  try {
    const clientSettings = await allSettings(
      datasheetDetails?.clientId,
      settings?.["companyHierarchy"] ? srfDetails?.companyHierarchy : "",
    );

    const settingList = clientSettings.reduce(
      (acc, { keyName, value }) => ({ ...acc, [keyName]: value }),
      {},
    );

    dispatch({
      field: "ClientSetting",
      value: settingList,
    });
  } catch (error) {
    console.error("Error fetching client settings:", error);
  }
}

export async function previousObservationJobNumber(
  datasheetId,
  datasheetDetails,
  datasheetStaticReadings,
  dispatch,
  selectedMasterORNot,
  autoLoadCount = 0,
) {
  try {
    const { DUCID, make, model, ranges, lc, instrumentId, deletedTableIds } = datasheetDetails || {};
  
    const formattedRanges = ranges.replaceAll("#", "_");
    const formattedLc = lc.replaceAll("#", "_");

    const query = `SELECT * FROM datasheetview WHERE status = 1 AND clientId = ${datasheetDetails?.clientId} AND totalReadings > 0 AND id != ${datasheetId} AND instrumentId = ${instrumentId} AND DUCID = '${DUCID}' AND make = '${make}' AND model = '${model}' AND ranges LIKE '${formattedRanges}' AND lc LIKE '${formattedLc}'`;

    const res = await axiosWithToken.post(BASE_URL + "dynamic", { query: query.trim() });
    const matchedDatasheets = res?.data || [];

    if (!matchedDatasheets || matchedDatasheets.length === 0) {
      alert("No matching datasheet found to auto-load.");
      return;
    }

    // Get the current datasheet based on passed index
    const selectedIndex = autoLoadCount % matchedDatasheets.length;
    const matchedDatasheet = matchedDatasheets[selectedIndex];

    // Clear previous readings
    const readingIds = datasheetStaticReadings
      .filter(e => e.datasheetId === datasheetId)
      .map(row => row.id);

    if (readingIds.length > 0) {
      await clearPreviousReadings("datasheetStaticReadings", "datasheetId", datasheetId);
    }
    // Load readings from matched datasheet
    await fetchStaticReadingRows(
      matchedDatasheet.id,
      dispatch,
      true,
      datasheetId,
      deletedTableIds,
      selectedMasterORNot,
    );

    alert(`Auto-loaded readings from Job Number: ${matchedDatasheet.JobNumber} (${selectedIndex + 1} of ${matchedDatasheets.length})`);
  } catch (error) {
    console.error("Auto-load failed:", error);
  }
}
